/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsChannelPriceResponseDto>>;
export function request(
  params: API.tms.logisticsChannelPrice.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelPrice/list`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
